import React from 'react'
import styled from 'styled-components'
import Button from 'react-bootstrap/Button'
import PropTypes from 'prop-types'
import { colors, breakpoints } from 'globalStyles'

const StyledWrapper = styled.div`
  .btn-outline {
    background-color: ${colors.sky_blue};
    box-shadow: none;
    border-radius: 8px 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: ${colors.secondary_black};
    position: relative;
    width: 100%;
    height: 52px;

    @media only screen and ${breakpoints.phone} {
      font-size: 14px;
      line-height: 18px;
      height: 44px;
      padding: 12px;
    }
    @media only screen and ${breakpoints.tablet} {
      padding: 16px 24px;
    }
    @media only screen and ${breakpoints.desktop} {
      font-size: 16px;
      line-height: 24px;
      height: 124px;
      width: 238px;
      padding: 24px;
    }
  }
  .btn-outline:hover {
    color: ${colors.text_link_hover};
  }
  .btn-outline:focus {
    border: 1px solid ${colors.primary_blue};
    color: ${colors.text_link_hover};
    box-shadow: none;
  }
  .btn-outline:disabled {
    background-color: ${colors.web_grey};
    color: ${colors.primary_dark_grey};
    font-weight: 600;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);
  }
  .checkmark_full,
  .checkmark_empty {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 25%;
    right: 3.51%;
    z-index: 1;
    @media only screen and ${breakpoints.desktop} {
      top: 18%;
      right: 15%;
    }
  }
  .button-content {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-direction: row;
    @media only screen and ${breakpoints.desktop} {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
  }
`

export const OutlineButton = ({ icon, label, action, stored, storedIcon, disable }) => {
  const handleEvent = () => action()
  return (
    <StyledWrapper>
      <Button variant="outline" onClick={handleEvent} disabled={disable}>
        {stored && <img src={storedIcon} alt="filled" className="checkmark_full" />}
        <span className="button-content">
          {icon}
          {label}
        </span>
      </Button>
    </StyledWrapper>
  )
}

OutlineButton.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  action: PropTypes.func,
  stored: PropTypes.bool,
  storedIcon: PropTypes.string,
  disable: PropTypes.bool,
}

OutlineButton.defaultProps = {
  action: null,
  stored: false,
  storedIcon: '',
  disable: false,
}

const Buttons = {}

export default Buttons
